// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"e8458f46","513":"dfad1a5e","787":"a2ef04a6"}[chunkId] + ".chunk.js";
};